import { bathroomUnmapper, bedroomUnmapper, buildSelectedFilters, gradeUnmapper, isPopularDestination, PROPERTY_CALLOUT_BADGE_ID, } from '@awaze/mfe-common.api.site-search-service';
const generateSearchDestinationCategorySingleCharacterExclusions = [
    '',
    '/',
    '?',
    '&',
];
export const formatDataLayerString = (unformattedString) => {
    return unformattedString
        .toLowerCase()
        .replace(/[^\w\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};
/* eslint-disable no-restricted-globals */
export const isValidDate = (date) => {
    return (new Date(date) instanceof Date &&
        !isNaN(new Date(date)));
};
/* eslint-enable */
export const getISODate = (date) => {
    return (date &&
        (isValidDate(date) && new Date(date).toISOString().split('T')[0] === date
            ? date
            : date.split('-').reverse().join('-')));
};
export const generateSearchDestinationCategory = (destinationUrl, accommodationType) => {
    const destinationURLWithoutFirstSlash = destinationUrl.substring(1);
    const destinationURLWithNoAccommType = destinationURLWithoutFirstSlash.replace(accommodationType, '');
    const destinationURLParts = destinationURLWithNoAccommType.split(/(\/|\?|&)+/);
    const removeSingleCharacterArrayItems = destinationURLParts.filter((el) => el !== undefined &&
        el !== null &&
        !generateSearchDestinationCategorySingleCharacterExclusions.includes(el));
    const rhsElementsParsed = removeSingleCharacterArrayItems.map((el) => el.replace(/rhs\d=/, ''));
    const filterUrlParams = rhsElementsParsed.filter((el) => !el.includes('='));
    return filterUrlParams.join('|');
};
export const generateDataLayerBaseProductList = ({ properties, accommodationType = 'cottages', propertyCode, site, }) => {
    const mapping = {
        product_parent_id: [],
        product_parent_name: [],
        product_parent_brand: [],
        product_parent_review_score: [],
        product_parent_location: [],
        product_parent_location_category: [],
        product_sku: [],
        product_name: [],
        product_type: [],
        product_grade: [],
        product_capactiy: [],
        product_bedrooms: [],
        product_bathrooms: [],
        product_pets: [],
        product_key_features: [],
        product_list_availability: [],
        product_list_price: [],
        product_list_strikethrough_price: [],
        product_list_badge: [],
        product_is_free_cancellation: [],
        product_review_score: [],
    };
    if (properties && properties.length > 0) {
        const clickedProperty = propertyCode
            ? properties.find((property) => property.code === propertyCode)
            : null;
        const renderedProperties = clickedProperty
            ? [clickedProperty]
            : properties;
        renderedProperties.forEach((property) => {
            const features = property.features || [];
            const availability = property.startDate
                ? [{ startDate: property.startDate, price: property.price }]
                : [];
            const isCustomerChoice = property.features?.some(({ featureId }) => featureId === PROPERTY_CALLOUT_BADGE_ID) || false;
            const productParentId = site?.code || property.code || '';
            const productParentName = site?.displayName || property.displayName || '';
            /* eslint-disable no-nested-ternary */
            const productSku = accommodationType === 'cottages'
                ? property.code || ''
                : site
                    ? property.code
                    : '';
            /* eslint-enable */
            const propertyDisplayName = property.displayName || '';
            const bedroomCount = property.property?.bedrooms || '';
            const petCount = property.property?.pets || '';
            const sleeps = property.property?.sleeps || '';
            const bathroomCount = property.property?.bathrooms || '';
            const grade = property.grade || '';
            const averageReviewScore = property.averageReviewScore || '';
            const wasPrice = property.wasPrice || '';
            const productParentLocationCategory = property.rhs3 || '';
            const productParentLocation = property.location || '';
            const displayedPrice = property.price || property.priceFrom || '';
            const propertyFeaturesFormatted = features
                ? features
                    .map((feature) => formatDataLayerString(feature.featureName))
                    .join(',')
                : '';
            const propertyListAvailability = availability.length > 0 ? availability?.length?.toString() : '';
            const propertyListBadge = isCustomerChoice ? 'is customer choice' : '';
            mapping.product_parent_id.push(productParentId);
            mapping.product_parent_name.push(formatDataLayerString(productParentName));
            mapping.product_parent_brand.push('');
            mapping.product_parent_review_score.push('');
            mapping.product_parent_location.push(formatDataLayerString(productParentLocation));
            mapping.product_parent_location_category.push(formatDataLayerString(productParentLocationCategory));
            mapping.product_sku.push(productSku);
            mapping.product_name.push(formatDataLayerString(propertyDisplayName));
            mapping.product_type.push(formatDataLayerString(''));
            mapping.product_grade.push(formatDataLayerString(grade));
            mapping.product_capactiy.push(formatDataLayerString(sleeps?.toString()));
            mapping.product_bedrooms.push(formatDataLayerString(bedroomCount?.toString()));
            mapping.product_bathrooms.push(formatDataLayerString(bathroomCount?.toString()));
            mapping.product_pets.push(formatDataLayerString(petCount?.toString()));
            mapping.product_key_features.push(propertyFeaturesFormatted);
            mapping.product_list_availability.push(propertyListAvailability);
            mapping.product_list_price.push(displayedPrice?.toString());
            mapping.product_list_strikethrough_price.push(wasPrice?.toString());
            mapping.product_list_badge.push(propertyListBadge);
            mapping.product_is_free_cancellation.push('');
            mapping.product_review_score.push(formatDataLayerString(averageReviewScore?.toString()));
        });
    }
    return mapping;
};
export const generateDataLayerProductList = ({ page, properties, accommodationType = 'cottages', propertyCode, pageSize, site, }) => {
    const dataLayerBaseProductList = generateDataLayerBaseProductList({
        properties,
        accommodationType,
        propertyCode,
        site,
    });
    const mapping = {
        product_list_position: [],
        ...dataLayerBaseProductList,
    };
    if (properties && properties.length > 0) {
        const clickedProperty = propertyCode
            ? properties.find((property) => property.code === propertyCode)
            : null;
        const renderedProperties = clickedProperty
            ? [clickedProperty]
            : properties;
        renderedProperties.forEach((_, index) => {
            const propertyPosition = clickedProperty
                ? properties.indexOf(clickedProperty)
                : index;
            const propertyListPosition = ((page - 1) * pageSize +
                (propertyPosition + 1))?.toString();
            mapping.product_list_position.push(propertyListPosition);
        });
    }
    return mapping;
};
export const buildDataLayerProductList = ({ searchCriteria, searchData, propertyCode, pageSize, }) => generateDataLayerProductList({
    page: searchCriteria?.page || 0,
    pageSize,
    properties: searchData?.properties,
    site: searchData?.site,
    accommodationType: searchCriteria.accommodationType,
    propertyCode,
});
export const buildDataLayerBaseProductList = ({ searchCriteria, searchData, propertyCode, }) => generateDataLayerBaseProductList({
    properties: searchData?.properties,
    site: searchData?.site,
    accommodationType: searchCriteria.accommodationType,
    propertyCode,
});
export const generateDataLayerSearch = ({ accommodationType, adult, child, destinationURL, infant, pets, nights, range, regionName, start, }) => {
    const hasDestinationURL = destinationURL && destinationURL !== '';
    return {
        search_destination: regionName ? formatDataLayerString(regionName) : 'all',
        search_destination_category: accommodationType
            ? generateSearchDestinationCategory(hasDestinationURL ? destinationURL : '/all', accommodationType)
            : '',
        search_start_date: (start && getISODate(start)) || 'not selected',
        search_duration: formatDataLayerString(nights?.toString() || 'not selected'),
        search_flexibility: formatDataLayerString(range?.toString() || 'not selected'),
        search_adults: formatDataLayerString(adult?.toString() || 'not selected'),
        search_children: formatDataLayerString(child?.toString() || 'not selected'),
        search_infants: formatDataLayerString(infant?.toString() || 'not selected'),
        search_pets: formatDataLayerString(pets?.toString() || 'not selected'),
    };
};
export const buildDataLayerSearch = ({ searchCriteria, }) => {
    const { accommodationType, adult, child, destinationURL, infant, nights, pets, range, regionName, start, } = searchCriteria;
    return generateDataLayerSearch({
        accommodationType,
        adult,
        child,
        destinationURL,
        infant,
        pets,
        nights,
        range,
        regionName,
        start,
    });
};
export const formatSearchDestinationCategory = (destinationUrl, accommodationType, googleSearch) => {
    if (googleSearch)
        return googleSearch;
    const destinationURLWithoutFirstSlash = destinationUrl.substring(1);
    const destinationURLWithNoAccommType = destinationURLWithoutFirstSlash.replace(accommodationType, '');
    const destinationURLParts = destinationURLWithNoAccommType.split('/');
    const removeEmptyArrayItems = destinationURLParts.filter((el) => el !== undefined && el !== null && el !== '');
    return removeEmptyArrayItems.join('|');
};
export const buildDataLayerSearchSubmit = (searchFormData) => {
    return {
        search_destination: searchFormData.destination
            ? formatDataLayerString(searchFormData.destination)
            : 'all',
        search_destination_category: formatSearchDestinationCategory(searchFormData.destinationURL && searchFormData.destinationURL !== ''
            ? searchFormData.destinationURL
            : '/all', searchFormData.accommodationType ?? '', searchFormData?.googleSearch ?? ''),
        search_start_date: searchFormData.start
            ? getISODate(searchFormData.start)
            : 'not selected',
        search_duration: formatDataLayerString(searchFormData.nights.toString()),
        search_flexibility: formatDataLayerString(searchFormData.range.toString()),
        search_adults: formatDataLayerString(searchFormData.adult.toString()),
        search_children: formatDataLayerString(searchFormData.child.toString()),
        search_infants: formatDataLayerString(searchFormData.infant.toString()),
        search_pets: formatDataLayerString(searchFormData.pets.toString()),
        search_accommodation_type: searchFormData.accommodationType
            ? formatDataLayerString(searchFormData.accommodationType.toString())
            : '',
    };
};
export const generateDataLayerFacetSelection = ({ aggregations, features, bathrooms, bedrooms, grade, rating, }) => {
    const justFeatures = aggregations.features.filter(({ featureId }) => !isPopularDestination(featureId));
    const popularDestinations = aggregations.features.filter(({ featureId }) => isPopularDestination(featureId));
    const adjustedAggregations = {
        ...aggregations,
        features: justFeatures,
        popularDestinations,
    };
    const groupedFeatures = {
        features: features
            ? features.filter((featureId) => !isPopularDestination(featureId))
            : [],
        popularDestinations: features
            ? features.filter((featureId) => isPopularDestination(featureId))
            : [],
    };
    return Object.keys(adjustedAggregations)
        .map((section) => {
        if (groupedFeatures &&
            ['features', 'popularDestinations'].includes(section)) {
            const selectedFilters = buildSelectedFilters(groupedFeatures[section], adjustedAggregations[section]);
            const selectedFeatures = selectedFilters
                .filter((filter) => typeof filter.featureName === 'string')
                .map(({ featureName }) => {
                // @ts-ignore : Type guarding for objects doesn't cascade for filter method
                return formatDataLayerString(featureName);
            });
            return selectedFeatures.length > 0
                ? `${section}-${selectedFeatures.join('_')}`
                : false;
        }
        if (bedrooms && section === 'bedrooms') {
            const bedroomSelection = bedroomUnmapper(bedrooms);
            return bedroomSelection ? `bedrooms-${bedroomSelection}` : false;
        }
        if (bathrooms && section === 'bathrooms') {
            const bathroomSelection = bathroomUnmapper(bathrooms);
            return bathroomSelection ? `bathrooms-${bathroomSelection}` : false;
        }
        if (grade && section === 'grades') {
            const gradeSelection = gradeUnmapper(grade);
            return gradeSelection ? `grades-${gradeSelection}` : false;
        }
        if (section === 'reviews') {
            return rating ? `reviews-${rating.replace('-', '_')}` : false;
        }
        return false;
    })
        .filter((section) => section)
        .join('|');
};
export const generateDataLayerBaseShopList = ({ aggregations, bathrooms, bedrooms, features, grade, rating, }) => ({
    shop_list_facet_selection: aggregations
        ? generateDataLayerFacetSelection({
            aggregations,
            bathrooms,
            bedrooms,
            features,
            grade,
            rating,
        })
        : '',
});
export const buildDataLayerMapView = ({ searchCriteria, aggregations, }) => {
    const { bathrooms, bedrooms, features, grade, rating } = searchCriteria;
    return {
        ...generateDataLayerBaseShopList({
            aggregations,
            bathrooms,
            bedrooms,
            features,
            grade,
            rating,
        }),
        ...buildDataLayerSearch({
            searchCriteria,
        }),
    };
};
export const buildDataLayerMapViewFail = ({ aggregations, errorCode, errorReason, searchCriteria, }) => {
    const baseData = buildDataLayerMapView({ searchCriteria, aggregations });
    return {
        ...baseData,
        error_code: errorCode,
        error_reason: errorReason,
    };
};
export const generateDataLayerShopList = ({ aggregations, bathrooms, bedrooms, features, grade, rating, sort = '', }) => ({
    shop_list_sort: formatDataLayerString(sort),
    ...generateDataLayerBaseShopList({
        ...(aggregations && { aggregations }),
        bathrooms,
        bedrooms,
        features,
        grade,
        rating,
    }),
});
export const buildDataLayerShopList = ({ searchCriteria, searchData, }) => {
    const { bathrooms, bedrooms, features, grade, rating, sort } = searchCriteria;
    return generateDataLayerShopList({
        ...(searchData && { aggregations: searchData.aggregations }),
        bathrooms,
        bedrooms,
        features,
        grade,
        rating,
        sort,
    });
};
export const buildDataLayerBaseShopList = ({ searchCriteria, searchData, }) => {
    const { bathrooms, bedrooms, features, grade, rating } = searchCriteria;
    return generateDataLayerBaseShopList({
        ...(searchData && { aggregations: searchData.aggregations }),
        bathrooms,
        bedrooms,
        features,
        grade,
        rating,
    });
};
export const isTmsReady = (tms) => {
    const windowAvailable = typeof window !== 'undefined';
    const windowTmsEventsAvailable = windowAvailable && typeof window.tmsevents !== 'undefined';
    return windowTmsEventsAvailable && typeof tms !== 'undefined';
};
export const generateDataLayerAvailability = ({ availabilityData, }) => {
    return {
        availability_adults: availabilityData.adults,
        availability_children: availabilityData.children,
        availability_infants: availabilityData.infants,
        availability_start_date: getISODate(availabilityData.startDate),
        availability_duration: availabilityData.duration,
        availability_pets: availabilityData.pets,
    };
};
//# sourceMappingURL=DataLayerUtils.js.map